import { Component, OnInit } from '@angular/core';
import { BillingInvoiceEditService } from '../../../services/billing/billing-invoice/billing-invoice-edit.service';
import { BillingInvoiceManualCreditEditService } from '../../../services/billing/billing-invoice-manual/billing-invoice-manual-credit-edit.service';
import { MenuService } from 'src/app/services/menu.service';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-billing-invoice-manual-credit-edit',
  templateUrl: './billing-invoice-manual-credit-edit.component.html',
  styleUrls: ['./billing-invoice-manual-credit-edit.component.css'],
  providers: [{ provide: BillingInvoiceEditService, useClass: BillingInvoiceManualCreditEditService }]
})
export class BillingInvoiceManualCreditEditComponent implements OnInit {

  enabledClientSearch = false;
  loading = false;

  constructor  ( private menuService: MenuService,
                 private billingInvoiceEditService: BillingInvoiceEditService,
                 private authService: AuthService,
                 private route: ActivatedRoute ) {

    this.menuService.setMenuTitle('Nota de crédito');
  }


  ngOnInit() {

    this.loading = true;
    const invoiceId = this.route.snapshot.paramMap.get('InvoiceId');
    this.billingInvoiceEditService.setBillingInvoiceCreditParams(
        this.authService.getSectorId(), invoiceId ? +invoiceId : null );
    this.loading = false;

  }

}
